const PATH = "/api/v1/admin";

const ENDPOINTS = {
  ADMIN_PROFILE: "/profile/",
  ADMIN_PROFILE_SEARCH: "/profile/search/",
  ADMIN_APP_CLIENT: "/app-client/",
  ADMIN_ACCESS_GROUP: "/access-group/",
  ADMIN_ACCESS_LIST: "/access-list/",
  ADMIN_ACCESS: "/access/",
  ADMIN_SEED: "/seed/",
  ADMIN_ADMIN_WALLET_TRANSACTIONS: "/wallet-transactions/",
  ADMIN_PROFILES: "/profiles/",
  ADMIN_ASSOCIATION: "/association/",
  ADMIN_USER_ACCESS_GROUP: "/user-access-group/",
  ADMIN_INSTA_POST: "/insta/post/",
  ADMIN_INSTA_HASHTAG: "/insta/hashtag",
  ADMIN_TELEPHONY_USER: "/telephony/user/",
  ADMIN_TELEPHONY_GROUP: "/telephony/group/",
  ADMIN_TELEPHONY_NUMBER: "/telephony/number/",
  ADMIN_TELEPHONY_CALL: "/telephony/call/",
  ADMIN_TELEPHONY_RATE_CALL: "/telephony/rate_call/",
  ADMIN_TELEPHONY_AUDIT_REPORT: "/telephony/audit_report/",
  ADMIN_TELEPHONY_CONNECT: "/telephony/connect/",
};

export type AdminEndpoints = keyof typeof ENDPOINTS;
export const AdminCollection = { PATH, ENDPOINTS };
